(function ($) {
    'use strict';


    $(document).on('show.bs.collapse hide.bs.collapse', '.collapse', function (event) {
        if (event.isDefaultPrevented()) return true;

        var show   = event.type === 'show',
            $panel = $(this).closest('.panel');

        $panel && $panel.length && $panel[(show ? 'add' : 'remove') + 'Class']('panel-expanded');
    });
})(window.jQuery);
